// AUTO-GENERATED by asyncapi-cable from the cable AsyncAPI documents.
// Do not edit by hand — regenerate with the asyncapi-cable CLI.

import { Channel } from "@anycable/core";
import type { CurrentUserJobStatusMessage } from "../models/CurrentUserJobStatusMessage";
import type { CurrentUserActionJobStatusMessage } from "../models/CurrentUserActionJobStatusMessage";
import type { CurrentUserAiMessageJobStatusMessage } from "../models/CurrentUserAiMessageJobStatusMessage";
import type { CurrentUserTextExtractJobStatusMessage } from "../models/CurrentUserTextExtractJobStatusMessage";
import type { CurrentUserH5pContentJobStatusMessage } from "../models/CurrentUserH5pContentJobStatusMessage";

/** Alternatives declared for the operation — AsyncAPI treats a channel's messages as a union. */
export type CurrentUserJobStatusData = CurrentUserJobStatusMessage | CurrentUserActionJobStatusMessage | CurrentUserAiMessageJobStatusMessage | CurrentUserTextExtractJobStatusMessage | CurrentUserH5pContentJobStatusMessage;

/** Params the client supplies at subscribe time. */
export type CurrentUserJobStatusParams = Record<string, never>;

export class CurrentUserJobStatusChannel extends Channel<CurrentUserJobStatusParams, CurrentUserJobStatusData> {
  static identifier = "CurrentUserJobStatusChannel";
}
